import { type ICategory, MainCategoryEnum, SubCategoryEnum } from '@insights/insights-data-provider'

import type { StartGalleryFilter } from '@/features/start-gallery'

/**
 * Checklist for Adding an Event
 *
 * 1. Add key (event name) in `customEvents` with valid categories
 * 2. Add same key in `EventPayloads` and define payload type
 */

export const customEvents = {
  filter_modular: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  filter_removable_cover: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  filter_sofa_bed: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  filter_storage: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  filter_width: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  filter_recline: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  open_cover_information: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.navigation },
  open_less_similar_products: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.navigation },
  open_less_variations: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.navigation },
  open_more_similar_products: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.navigation },
  open_more_variations: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.navigation },
  open_product_information: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.navigation },
  select_gallery_sofa: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.navigation },
  select_measurements: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  select_part_picker: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  select_range_feature: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  select_redo: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  select_similar_product: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  select_undo: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  select_variation: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.function },
  upptacka_exit_clicked: {
    mainCategory: MainCategoryEnum.interaction,
    subCategory: SubCategoryEnum.navigation,
  },
  upptacka_summary_clicked: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.navigation },
  whats_included_clicked: { mainCategory: MainCategoryEnum.interaction, subCategory: SubCategoryEnum.navigation },
} as const satisfies Record<string, ICategory>

type EventPayloads = {
  filter_modular: { isModular: boolean }
  filter_removable_cover: { hasRemovableCover: boolean }
  filter_sofa_bed: { hasSofabed: boolean }
  filter_storage: { hasStorage: boolean }
  filter_recline: { hasRecliningBackrest: boolean }
  filter_width: { width: StartGalleryFilter['width'] }
  open_cover_information: { open: boolean }
  open_less_similar_products: undefined
  open_less_variations: undefined
  open_more_similar_products: undefined
  open_more_variations: undefined
  open_product_information: undefined
  select_gallery_sofa: { index: number; itemNo: string; rangeId: string }
  select_measurements: { active: boolean }
  select_part_picker: { from: string; part: string; to: string }
  select_range_feature: { feature: string }
  select_redo: undefined
  select_similar_product: { id: string; index: number }
  select_undo: undefined
  select_variation: { from: string; index: number; to: string }
  upptacka_exit_clicked: undefined
  upptacka_summary_clicked: undefined
  whats_included_clicked: undefined
}

export type CustomEventPayloadRecord = {
  [K in keyof typeof customEvents]: EventPayloads[K]
}
